import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '../../api/login/loginApi';

const initialInfoUserSlice: IUser = {
  id: 0,
  image: "",
  unit: 0,
  username: "",
  groupPermission: null,
  role: false,
  unitTemp: 0,
  sessionTimeout: 5
}

const InfoUserSlice = createSlice({
  name: 'infoUserSlice',
  initialState: initialInfoUserSlice,
  reducers: {
    setInfoUser: (state, action: PayloadAction<IUser>) => {
      return {
        ...state,
        ...action.payload,
        sessionTimeout: state.sessionTimeout
      }
    },
    clearInfoUser: (state) => initialInfoUserSlice,

    setSessionTimeout: (state, action: PayloadAction<number>) => {
      state.sessionTimeout = action.payload
    }
  }
})

export const selectorInfoUser = (state: { infoUserSlice: IUser }) => state.infoUserSlice;
export const { setInfoUser, clearInfoUser, setSessionTimeout } = InfoUserSlice.actions;
export default InfoUserSlice.reducer;
